// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-pages-business-components-FormContent-components-RizhaoContent-__index__wrap--yqb_R"};